import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import BidBadge from '../../../../_shared/components/BidBadge';
import Loading from '../../../../_shared/components/Loading';
import BidBoxContext from '../../BidBoxContainer/BidBoxContext';
import {
  AuctionTimerType,
  TradeState,
  TradeStateName,
  TradeViewVariant
} from '../../../../_shared/types/trade';
import ActiveTimer from '../../../../_shared/components/ActiveTimer';
import {
  StyledHeader,
  StyledState,
  StyledActiveTimerContainer
} from './Styles';

const Header = ({ isLoading, onAuctionEnded, isOmp = false }) => {
  const { bidContext } = useContext(BidBoxContext);
  const {
    activeExpiryTime,
    isAuctionEnded,
    tradeState,
    id,
    auctionSummary,
    isTimerExtended
  } = bidContext ?? {};
  const isAuctionExtended = () =>
    [TradeState.active].includes(tradeState) &&
    (isTimerExtended || auctionSummary?.isTimerExtended);

  const getTimerVariant = currentTradeState => {
    switch (currentTradeState) {
      case TradeState.pending:
        return AuctionTimerType.PENDING;
      case TradeState.closing:
        return AuctionTimerType.CLOSING;
      case TradeState.active:
        return AuctionTimerType.ACTIVE;
      default:
        return null;
    }
  };

  return isLoading ? (
    <StyledHeader>
      <Loading width="100px" height="20px" />
      <Loading width="50px" height="20px" />
    </StyledHeader>
  ) : (
    <StyledHeader id="styledHeader">
      <StyledState data-testid="trade-state" isOmp={isOmp}>
        {/* Active/Upcoming */}
        {tradeState ? (
          <FormattedMessage
            id={`vdp.bid.tradeState.${TradeStateName[
              tradeState
            ]?.toLowerCase()}`}
          />
        ) : (
          <Loading width="100px" height="20px" />
        )}
      </StyledState>
      {isAuctionEnded && tradeState === TradeState.active ? (
        <BidBadge variant="disabled">
          {/* Auction Ended */}
          <FormattedMessage id="vdp.auctionEnded" />
        </BidBadge>
      ) : (
        [TradeState.active, TradeState.pending, TradeState.closing].includes(
          tradeState
        ) && (
          <StyledActiveTimerContainer
            id="styledActiveTimer"
            isAuctionEnded={isAuctionEnded}
          >
            <ActiveTimer
              onAuctionEnded={onAuctionEnded}
              activeExpiryTime={activeExpiryTime}
              location={TradeViewVariant.VDP}
              tradeId={id}
              isTimerExtended={isAuctionExtended()}
              variant={getTimerVariant(tradeState)}
            />
          </StyledActiveTimerContainer>
        )
      )}
    </StyledHeader>
  );
};

export default Header;
